import script from "./Setup2FA.vue?vue&type=script&setup=true&lang=js"
export * from "./Setup2FA.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__